import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {find} from "lodash"
import moment from "moment"

import {Radio} from "@irati/ui/src/FormItem"
import {TextButton} from "@irati/ui/src/Button"
import theme from "@irati/ui/src/global/theme"
import Validation from "@irati/utils/validation"
import {injectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"

const Custom = styled(TextButton)`
  color: ${theme.colors.perkbox.blue};
  text-decoration: underline;
  font-weight: 100;
`

export const schema = Validation.string("platform.defaultValidation.required")

const PROPERTY = "endsAt"

const OPTIONS = (intl) => [
  {label: intl.formatMessage({id: "recognition.fields.poll.endDate.oneDay.label"}), value: "1"},
  {label: intl.formatMessage({id: "recognition.fields.poll.endDate.threeDays.label"}), value: "3"},
  {label: intl.formatMessage({id: "recognition.fields.poll.endDate.sevenDays.label"}), value: "7"}
]

const CUSTOM_OPTION_VALUE = "CUSTOM_OPTION_VALUE"

class EndDate extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onCustomDate: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    validation: PropTypes.object,
    label: PropTypes.string
  }

  static defaultProps = {
    validation: schema,
    label: "recognition.fields.poll.endDate.label",
    id: "poll"
  }

  handleChange = (value) => {
    const {onCustomDate, poll, onChange} = this.props
    if (value === CUSTOM_OPTION_VALUE) {
      return onCustomDate()
    }

    const date = moment().hour(17).minute(0).second(0)
    date.day(date.day() + parseInt(value, 10))

    onChange(poll, PROPERTY, date)
  }

  getValue = () => {
    const {intl, poll} = this.props

    const value = poll[PROPERTY]
    const endsAt = moment(value)
    const today = moment(moment().format("YYYY-MM-DD"))

    if (!value || !endsAt.isValid()) {
      return null
    }

    const days = `${endsAt.diff(today, "days")}`
    const found = find(OPTIONS(intl), (test) => test.value === days)

    return found ? days : CUSTOM_OPTION_VALUE
  }

  customDate = () => {
    const {onCustomDate, intl} = this.props

    const isCustom = this.getValue() === CUSTOM_OPTION_VALUE
    const value = this.props.poll[PROPERTY]

    return {
      label: (
        <Custom id={id("setDate", this.props)} onClick={onCustomDate}>
          {isCustom ? value.format("Do MMM YYYY") : intl.formatMessage({id: "recognition.fields.poll.endDate.setDate"})}
        </Custom>
      ),
      value: CUSTOM_OPTION_VALUE
    }
  }

  render() {
    const {poll, intl, ...props} = this.props

    return (
      <Radio
        options={[...OPTIONS(intl), this.customDate()]}
        {...props}
        inline
        onChange={this.handleChange}
        name={id(PROPERTY, this.props)}
        id={id(PROPERTY, this.props)}
        value={this.getValue()}
      />
    )
  }
}

export default injectIntl(EndDate)
